<script lang="ts">
    export let text: string = 'Not found anything';
</script>


<div class="text">{text}</div>


<style>
    .text {
        font-size: 14px;
        opacity: 0.5;
        width:100%;
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 50px;
    }
</style>